import { render, staticRenderFns } from "./StrainBase.vue?vue&type=template&id=03756201&"
import script from "./StrainBase.vue?vue&type=script&lang=js&"
export * from "./StrainBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports